export const ALARM_CONFIG = {
  INTERVALS: {
    CHECK_ALARM_MS: 10000,
    TIME_UPDATE_MS: 1000,
    NOTE_CHANGE_MS: 800,
  },
  AUDIO: {
    INITIAL_VOLUME: 0.1,
    TV_ALARM_VOLUME: 5,
    NOTES: {
      A4: 440,
      C5: 523,
      E5: 659,
    },
    SEQUENCE: [440, 523, 659, 523],
  },
  DEFAULTS: {
    HOURS: 7,
    MINUTES: 0,
    MODE: 'sound' as const,
  },
} as const

export type WakeUpMode = 'sound' | 'channel'
